import { DateTime } from 'luxon';
import { App } from 'vue';

import { Installable } from '@rygen/rygen-ui/config/Installable';

function refreshWithCacheBustingParameter() {
  let url: URL;
  try {
    url = new window.URL(window.location.href);
  } catch (e) {
    console.warn('cannot parse current href');
    return window.location.reload();
  }

  url.searchParams.set('_cb_', Date.now().toString());
  window.location.href = url.href;
}

export class CacheBustingInstaller implements Installable {
  install(_app: App): void {
    const now = DateTime.now();
    // Refresh the page at 3am tomorrow
    const refreshTime = now.plus({ days: 1 }).startOf('day').plus({ hours: 3 });
    const millisUntilRefresh = refreshTime.diff(now).toMillis();
    setTimeout(() => refreshWithCacheBustingParameter(), millisUntilRefresh);
  }
}

export const cacheBusting = new CacheBustingInstaller();
